import { useState, useEffect } from 'react';
import axiosInstance from '../../helpers/axios';
import DatePicker from "react-multi-date-picker";
import calender from "../../assets/images/calender.png";
import moment from 'moment';
import CircularProgress from '@mui/material/CircularProgress';
import Box from '@mui/material/Box';
import PaginationTable from "../status/PaginationTable";
import { useSelector } from "react-redux";

export default function Mandatepausedreport() {
    const [PausedData, setPausedData] = useState([])
    const [PausedstartDate,setPausedStartDateFrom] = useState()
    const [pausedendDate,setPuasedEndDateTo] = useState()
    const [isLoading, setIsLoading] = useState(false); 
    const [currentPage,setCurrentPage]=useState(1)
    const [rowsPerPage,setRowsPerPage]=useState(15)
    const [totalFetchRows,setTotalFetchRows]=useState(0)
  const [activePage, setActivePage] = useState(15);
  
    const user = null;
  const productTypeSelected = useSelector((state) => state.ProductTypeFilter.selectedProductType);
    useEffect(() => {
        
        setIsLoading(true)
        let queryParams={
          perPage:rowsPerPage,
          pageNo:currentPage
        }
      if (productTypeSelected && productTypeSelected !== "all") {
        queryParams.loanType = Number(productTypeSelected);
      }
        axiosInstance.get('/analytics/paused-report', {
          params:queryParams,
          headers: {
          },
         
        })
        .then((res) => {
          
          setPausedData(res?.data?.pausedreports?.Pausedreport || [])
          setTotalFetchRows(res?.data?.pausedreports?.pagination?.totalRows || 0);
          setIsLoading(false);
          const loadingTimeout = setTimeout(() => {
            setIsLoading(false);
          }, 300);

        })
        .catch((error) => {
        });
    
    }, [user, currentPage, rowsPerPage, productTypeSelected]); 
 
 
  const paginate = (pageNumber) => {
    setCurrentPage(pageNumber);
  };

  const handlepageChange = (number) => {
    setRowsPerPage(number);
    setCurrentPage(1);
    setActivePage(number);
  };

      const fetchingclosedData = ()=>{

        setIsLoading(true)

        let queryParams = {
          perPage: rowsPerPage,
          pageNo: currentPage,
        }
        if (productTypeSelected && productTypeSelected !== "all") {
          queryParams.loanType = Number(productTypeSelected);
        }
        if(PausedstartDate && pausedendDate){
            
            const formattedStartDate = moment(PausedstartDate, 'DD MMM YYYY').format('DD-MM-YYYY')
            const formattedEndDate =moment(pausedendDate, 'DD MMM YYYY').format('DD-MM-YYYY')
    
        queryParams.startDate = formattedStartDate;
        queryParams.endDate = formattedEndDate;
        }
        
       
    
        axiosInstance.get('/analytics/paused-report', {
          params: queryParams,
          headers: {
          },
        })
        .then((res) => {
    
            setPausedData(res?.data?.pausedreports?.Pausedreport||[]);
          setTotalFetchRows(res?.data?.pausedreports?.pagination?.totalRows || 0);
          setIsLoading(false);
            const loadingTimeout = setTimeout(() => {
                setIsLoading(false);
              }, 300);
         
        })
        .catch((error) => {
          alert(error?.response?.data?.message)
          console.error("Error fetching filtered data:", error);
        });
       }


       function formatNumberWithCommas(number) {
        return number?.toLocaleString('en-IN'); 
      }





  return (
    <div style={{width:"100%",backgroundColor:'white',height:'130%'}}>


    <p style={{textAlign:"center",fontFamily:'Inter-Medium',color:'#667085',fontSize:'25px'}}>Paused Mandates </p>


    <div style={{ display: 'flex' }}>

<div style={{ height:'30px',width:'15em', borderRadius: '20px',marginRight:"60px",marginTop:'-2px'}}>
<DatePicker
style={{ height:'33px', BorderRadius: '5px',padding: '2px', backgroundRepeat: 'no-repeat',
backgroundPosition: '5px center',
backgroundSize: '15px 15px', backgroundImage: `url(${calender})`, paddingLeft: '30px',fontSize:"14px", border:'1px solid #ccc',fontWeight:"normal", border:'1px solid #ccc'}}
placeholder="Select date range"
allowClear={true}
format="DD MMM YYYY"
onChange={(dates, dateStrings) => {

   
 setPausedStartDateFrom(dateStrings?.validatedValue[0])
 setPuasedEndDateTo(dateStrings?.validatedValue[1])
}}
range
/>
</div>

<div > 
<button style={{display: 'flex', alignItems: 'center',width:'130px',backgroundColor:'#D22129',height:'34px',borderStyle:'none',borderRadius:"5px",color:'white',fontFamily:"Inter-Medium",paddingLeft:'10px'}}
onClick={() =>{
  if (currentPage !== 1) {
    setCurrentPage(1);
  } else {
    fetchingclosedData(1, rowsPerPage);
  }
  }}
>
Search Results
</button>
</div>

</div>

  {isLoading ? (
                  <Box style={{ display: 'flex',alignItems:'center',justifyContent:'center',padding:'15%'}}>
                  <CircularProgress />
                </Box>
                ):(<>
    <table className='tables' style={{marginRight:'10px'}}>
        
  <thead className='table-heading'>
    <tr>
      <th style={{ fontSize: '14px', cursor: 'pointer', width: '8px%', fontFamily: "Inter-Medium", paddingLeft: '15px' }}>Loan Id</th>
      <th style={{ fontSize: '14px', cursor: 'pointer', width: '10px%', fontFamily: "Inter-Medium",paddingLeft: '10px' }}>Cust Name</th>
      <th style={{ fontSize: '14px', cursor: 'pointer', width: '10px%', fontFamily: "Inter-Medium",paddingLeft: '10px' }}>Inst Name</th>
      <th style={{ fontSize: '14px', cursor: 'pointer', width: '10px%', fontFamily: "Inter-Medium",paddingLeft: '10px' }}>Mobile</th>
      <th style={{ fontSize: '14px', cursor: 'pointer', width: '10px%', fontFamily: "Inter-Medium" }}>Loan Amount</th>
      <th style={{ fontSize: '14px', cursor: 'pointer', width: '15px%', fontFamily: "Inter-Medium" }}>Outstanding Amount</th>
      <th style={{ fontSize: '14px', cursor: 'pointer', width: '10px%', fontFamily: "Inter-Medium",paddingLeft: '10px' }}>Paused date</th>
      <th style={{ fontSize: '14px', cursor: 'pointer', width: '10px%', fontFamily: "Inter-Medium" }}>Emi's count</th>
      
      
     
    </tr>
  </thead>
  
  
  <tbody className='table-body'>
  {
    PausedData?.map((item, index) => (
            
      <tr className="table-row" key={index} style={{ lineHeight: "25px", backgroundColor: 'white' }}>
        {}
       <td style={{ fontSize: '14px', cursor: 'pointer', width: '10em', fontFamily: "Inter-Medium", color: '#667085', paddingLeft: '8px' }}>{item?.legacy_loan_id?item?.legacy_loan_id:'-'}</td>
       <td style={{ fontSize: '14px', cursor: 'pointer', width: '10em', fontFamily: "Inter-Medium", color: '#667085', paddingLeft: '8px' }}>{item?.customer_name?item?.customer_name:'-'}</td>
       <td style={{ fontSize: '14px', cursor: 'pointer', width: '10em', fontFamily: "Inter-Medium", color: '#667085', paddingLeft: '10px' }}>{item?.name?item?.name:'-'}</td>
       <td style={{ fontSize: '14px', cursor: 'pointer', width: '10em', fontFamily: "Inter-Medium", color: '#667085', paddingLeft: '10px' }}>{item?.mobile?item?.mobile:'-'}</td>
        <td style={{ fontSize: '14px', cursor: 'pointer', width: '10em', fontFamily: "Inter-Medium", color: '#667085' }}>₹{item?.loan_amount ?formatNumberWithCommas(Math.round(item?.loan_amount)):'-'}</td>
        <td style={{ fontSize: '14px', cursor: 'pointer', width: '10em', fontFamily: "Inter-Medium", color: '#667085' }}>₹{item?.total_principle_amount ?formatNumberWithCommas(Math.round(item?.total_principle_amount)):'-'}</td>
        <td style={{ fontSize: '14px', cursor: 'pointer', width: '10em', fontFamily: "Inter-Medium", color: '#667085' }}>{item?.updated_at ?item?.updated_at  : '-'}</td> 
        <td style={{ fontSize: '14px', cursor: 'pointer', width: '10em', fontFamily: "Inter-Medium", color: '#667085' }}>{item?.emi_count?item?.emi_count  : '-'}</td> 

      </tr> 
    ))}
  </tbody>
</table>
            {PausedData?.length > 0 ? (
              <>
                <div style={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  marginTop: "5px",
                  flexWrap: "wrap",
                  gap: "10px",
                  fontFamily: "Inter",
                  backgroundColor: "white"
                }}>
                  <div style={{
                    fontWeight: "bold",
                    fontSize: "14px",
                    whiteSpace: "nowrap",
                    color: "#344054"
                  }}>
                    {totalFetchRows > 0 ? (
                      <>
                        Showing {(currentPage - 1) * rowsPerPage + 1}-
                        {Math.min(currentPage * rowsPerPage, totalFetchRows)} records of {totalFetchRows} |
                      </>
                    ) : (
                      "No Records"
                    )}
                  </div>

                  <div style={{
                    display: "flex",
                    alignItems: "center",
                    gap: "5px",
                    whiteSpace: "nowrap"
                  }}>
                    <span style={{ fontWeight: "600", color: "#344054" }}>
                      Rows Per Pages :
                    </span>
                    <div style={{ display: "flex", gap: "4px" }}>
                      {[15, 50, 100, 500].map((size) => (
                        <span
                          key={size}
                          onClick={() => handlepageChange(size)}
                          style={{
                            cursor: "pointer",
                            padding: "4px 8px",
                            fontSize: "14px",
                            fontWeight: 500,
                            color: activePage === size ? "#D22129" : "#344054",
                            backgroundColor: activePage === size ? "#FFF2F3" : "",
                            borderRadius: "8px"
                          }}
                        >
                          {size}
                        </span>
                      ))}
                    </div>
                  </div>
                </div>
                <div style={{ backgroundColor: 'white',width: '100%', padding: '0 10px' }}>
                <PaginationTable
                  startPage={currentPage}
                  rowsPerPage={rowsPerPage}
                  totalRows={totalFetchRows}
                  paginate={paginate}
                  handlepageChange={handlepageChange}
                />
                </div>
              </>
            ) : null}
</>)}

    </div>

  )
}
